export interface UrlConfig {
  API_BASE_URL: string;
  SOCKET_URL: string;
  GOOGLE_MAP_API: string;
  SECRET: string;
  NODE_ENV: string;
}


const getEnvConfig = (): UrlConfig => {
  const env: UrlConfig = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "",
    SOCKET_URL: process.env.REACT_APP_SOCKET_URL || "",
    GOOGLE_MAP_API: process.env.REACT_APP_GOOGLE_MAP_API || "",
    SECRET: process.env.REACT_APP_SECRET || "",
    NODE_ENV: process.env.REACT_APP_ENV || "development",
  };
  return env;
};
// Rename the exported constant
export const urlConfig = getEnvConfig();
